// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__lbg0Z","closeBtn":"Modal_closeBtn__2Uwjp"};